/*
 * Copyright (c) 2019.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {FeatureValue} from './FeatureValue';
import {MarketplaceFeatureValue} from './MarketplaceFeatureValue';
import {MarketplaceMappingFeatureValuesData} from './MarketplaceMappingFeatureValuesData';

export interface MarketplaceMappingFeatureValues {
  featureValuesList: FeatureValue[];
  marketplaceFeatureValueList: MarketplaceFeatureValue[];
  marketplaceMappingFeatureValuesData: MarketplaceMappingFeatureValuesData[];
}
